(function() {
  'use strict';

  var section = document.querySelector('.fp-steps');
  if (!section || !('IntersectionObserver' in window)) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) return;

  var cards = Array.prototype.slice.call(section.querySelectorAll('.fp-step'));
  var nodes = Array.prototype.slice.call(section.querySelectorAll('.fp-steps__journey span'));
  var rails = Array.prototype.slice.call(section.querySelectorAll('.fp-steps__journey i'));
  if (cards.length !== 3) return;

  var STEP_MS = [9000, 3900, 3400];
  var HOLD_MS = 3800;
  var CARD_REST_MS = 1900;
  var singleColumn = window.matchMedia('(max-width: 760px)');

  var current = -1;
  var timer = null;
  var inView = false;
  var started = false;
  var runToken = 0;

  section.classList.add('fp-steps--motion');

  /* ——— Upload pill: counter and progress bar ——— */
  var uploadPill = cards[0].querySelector('.fp-step__upload-pill');
  var uploadCount = uploadPill && uploadPill.querySelector('strong');
  var uploadLabel = uploadCount && uploadCount.nextSibling;
  var uploadCountText = uploadCount ? uploadCount.textContent : '';
  var uploadLabelText = uploadLabel ? uploadLabel.textContent : '';
  var uploadTarget = parseInt(uploadCountText, 10) || 10;
  var progress = null;

  if (uploadPill) {
    progress = document.createElement('em');
    progress.className = 'fp-steps-progress';
    progress.setAttribute('aria-hidden', 'true');
    uploadPill.appendChild(progress);
  }

  /* ——— Choose card: tap ten photos in the camera roll ——— */
  var roll = cards[0].querySelector('.fp-roll');
  var rollViewport = roll && roll.querySelector('.fp-roll__viewport');
  var rollGrid = roll && roll.querySelector('.fp-roll__grid');
  var rollCount = roll && roll.querySelector('.fp-roll__count');
  var rollTap = roll && roll.querySelector('.fp-roll__tap');
  var rollCountText = rollCount ? rollCount.textContent : '';
  var picks = [];

  if (roll) {
    Array.prototype.forEach.call(roll.querySelectorAll('.fp-roll__cell'), function(cell) {
      var order = parseInt(cell.getAttribute('data-pick'), 10);
      if (order > 0) picks[order - 1] = cell;
    });
    picks = picks.filter(Boolean);
  }

  var PICK_START = 700;
  var PICK_GAP = 420;
  var SCROLL_AFTER = 6;
  var SCROLL_PAUSE = 1100;
  var UPLOAD_DELAY = 6000;
  var UPLOAD_MS = 1200;

  function rollOverflow() {
    return Math.max(0, rollGrid.offsetHeight - rollViewport.clientHeight);
  }

  function scrollRoll(y) {
    rollGrid.style.transform = y ? 'translateY(' + (-y) + 'px)' : '';
  }

  function setRollCount(n) {
    if (!rollCount) return;
    rollCount.textContent = n ? n + ' selected' : 'Select';
    restartClass(rollCount, 'is-tick');
  }

  function pickCell(cell, order, scroll) {
    cell.classList.add('is-picked');
    cell.querySelector('i').textContent = order;
    restartClass(cell, 'is-popping');
    setRollCount(order);
    if (rollTap) {
      rollTap.style.left = (rollViewport.offsetLeft + cell.offsetLeft + cell.offsetWidth / 2) + 'px';
      rollTap.style.top = (rollViewport.offsetTop + cell.offsetTop + cell.offsetHeight / 2 - scroll) + 'px';
      restartClass(rollTap, 'is-tapping');
    }
  }

  function resetRoll() {
    if (!roll) return;
    picks.forEach(function(cell, i) {
      cell.classList.add('is-picked');
      cell.classList.remove('is-popping');
      cell.querySelector('i').textContent = i + 1;
    });
    if (rollCount) rollCount.textContent = rollCountText;
  }

  function playRoll(token) {
    if (!roll || !picks.length) return;
    picks.forEach(function(cell) {
      cell.classList.remove('is-picked', 'is-popping');
      cell.querySelector('i').textContent = '';
    });
    rollGrid.style.transition = 'none';
    scrollRoll(0);
    void rollGrid.offsetWidth;
    rollGrid.style.transition = '';
    setRollCount(0);

    var scroll = 0;
    picks.forEach(function(cell, i) {
      var at = PICK_START + i * PICK_GAP + (i >= SCROLL_AFTER ? SCROLL_PAUSE : 0);
      setTimeout(function() {
        if (token === runToken) pickCell(cell, i + 1, scroll);
      }, at);
    });
    setTimeout(function() {
      if (token !== runToken) return;
      scroll = rollOverflow();
      scrollRoll(scroll);
    }, PICK_START + (SCROLL_AFTER - 1) * PICK_GAP + 300);
  }

  /* ——— Crop card: aim the tap at the square size chip ——— */
  var crop = cards[1].querySelector('.fp-crop');
  var cropChip = crop && crop.querySelector('.fp-crop__size--square');

  function aimCropTap() {
    if (!crop || !cropChip || !crop.clientWidth) return;
    var sizes = cropChip.parentNode;
    var x = sizes.offsetLeft + cropChip.offsetLeft + cropChip.offsetWidth / 2;
    var y = sizes.offsetTop + cropChip.offsetTop + cropChip.offsetHeight / 2;
    crop.style.setProperty('--chip-x', (x / crop.clientWidth * 100) + '%');
    crop.style.setProperty('--chip-y', (y / crop.clientHeight * 100) + '%');
  }

  function setUpload(count, label, fraction) {
    if (uploadCount) uploadCount.textContent = count === 1 ? '1 photo' : count + ' photos';
    if (uploadLabel) uploadLabel.textContent = label;
    if (progress) progress.style.setProperty('--fp-progress', fraction);
  }

  function resetUpload() {
    resetRoll();
    if (!uploadPill) return;
    uploadPill.classList.add('is-complete');
    if (uploadCount) uploadCount.textContent = uploadCountText;
    if (uploadLabel) uploadLabel.textContent = uploadLabelText;
    if (progress) progress.style.setProperty('--fp-progress', 1);
  }

  function playUpload(token) {
    playRoll(token);
    if (!uploadPill) return;
    uploadPill.classList.remove('is-complete');
    setUpload(0, ' uploading…', 0);
    var delay = UPLOAD_DELAY;
    var duration = UPLOAD_MS;
    var begin = null;

    function frame(now) {
      if (token !== runToken) return;
      if (begin === null) begin = now;
      var t = Math.min(1, Math.max(0, (now - begin - delay) / duration));
      var eased = 1 - Math.pow(1 - t, 2);
      setUpload(Math.round(eased * uploadTarget), ' uploading…', eased);
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        resetUpload();
      }
    }
    requestAnimationFrame(frame);
  }

  /* ——— Ship card: order status ticks forward ——— */
  var shipStatus = cards[2].querySelector('.fp-step__ship-pill strong');
  var shipStatusText = shipStatus ? shipStatus.textContent : '';
  var SHIP_STAGES = ['Printing…', 'Packed', shipStatusText];

  function setShip(text) {
    if (!shipStatus) return;
    shipStatus.textContent = text;
    shipStatus.classList.remove('is-tick');
    void shipStatus.offsetWidth;
    shipStatus.classList.add('is-tick');
  }

  function playShip(token) {
    if (!shipStatus) return;
    SHIP_STAGES.forEach(function(text, index) {
      setTimeout(function() {
        if (token === runToken) setShip(text);
      }, 150 + index * 850);
    });
  }

  function resetShip() {
    if (shipStatus) shipStatus.textContent = shipStatusText;
  }

  /* ——— Step state ——— */
  function restartClass(el, name) {
    el.classList.remove(name);
    void el.offsetWidth;
    el.classList.add(name);
  }

  function activate(index) {
    runToken++;
    current = index;
    section.classList.remove('is-complete');

    cards.forEach(function(card, i) {
      card.classList.toggle('is-done', i < index);
      if (i !== index) card.classList.remove('is-active');
    });
    nodes.forEach(function(node, i) {
      node.classList.toggle('is-on', i <= index);
      node.classList.toggle('is-current', i === index);
    });
    rails.forEach(function(rail, i) {
      rail.classList.toggle('is-filled', i < index);
    });

    if (index !== 0) resetUpload();
    if (index !== 2) resetShip();

    restartClass(cards[index], 'is-active');
    if (index === 0) playUpload(runToken);
    if (index === 1) aimCropTap();
    if (index === 2) playShip(runToken);
  }

  function finish() {
    cards.forEach(function(card) {
      card.classList.remove('is-active');
      card.classList.add('is-done');
    });
    nodes.forEach(function(node) {
      node.classList.add('is-on');
      node.classList.remove('is-current');
    });
    restartClass(section, 'is-complete');
  }

  /* ——— Desktop: autoplay the three steps in a loop while visible ——— */
  function schedule(fn, ms) {
    clearTimeout(timer);
    timer = setTimeout(fn, ms);
  }

  function next() {
    if (!inView || document.hidden) return;
    if (current >= 2) {
      finish();
      schedule(function() {
        if (!inView || document.hidden) return;
        activate(0);
        schedule(next, STEP_MS[0]);
      }, HOLD_MS);
      return;
    }
    activate(current + 1);
    schedule(next, STEP_MS[current]);
  }

  function resume(delay) {
    clearTimeout(timer);
    if (!inView || document.hidden) return;
    schedule(next, delay);
  }

  var grid = section.querySelector('.fp-steps__grid') || section;
  var sectionObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var wasInView = inView;
      inView = entry.isIntersecting;
      if (singleColumn.matches || inView === wasInView) return;
      if (!inView) {
        clearTimeout(timer);
        return;
      }
      if (!started) {
        started = true;
        schedule(next, 500);
      } else {
        resume(700);
      }
    });
  }, { threshold: 0.45 });

  document.addEventListener('visibilitychange', function() {
    if (singleColumn.matches) {
      if (document.hidden) cards.forEach(stopCard);
      return;
    }
    if (document.hidden) clearTimeout(timer);
    else resume(900);
  });

  /* ——— Mobile: each stacked card loops while it is on screen ——— */
  var cardTimers = [];

  function playCard(card) {
    var index = cards.indexOf(card);
    runToken++;
    card.classList.remove('is-done');
    restartClass(card, 'is-active');
    if (index === 0) playUpload(runToken);
    if (index === 1) aimCropTap();
    if (index === 2) playShip(runToken);
    clearTimeout(cardTimers[index]);
    cardTimers[index] = setTimeout(function() {
      card.classList.remove('is-active');
      card.classList.add('is-done');
      cardTimers[index] = setTimeout(function() { playCard(card); }, CARD_REST_MS);
    }, STEP_MS[index]);
  }

  function stopCard(card) {
    var index = cards.indexOf(card);
    clearTimeout(cardTimers[index]);
    if (!card.classList.contains('is-active')) return;
    card.classList.remove('is-active');
    card.classList.add('is-done');
    if (index === 0) resetUpload();
    if (index === 2) resetShip();
  }

  var cardObserver = new IntersectionObserver(function(entries) {
    if (!singleColumn.matches) return;
    entries.forEach(function(entry) {
      if (entry.isIntersecting && !document.hidden) playCard(entry.target);
      else stopCard(entry.target);
    });
  }, { threshold: 0.55 });

  function setMode() {
    clearTimeout(timer);
    cardTimers.forEach(clearTimeout);
    runToken++;
    current = -1;
    started = false;
    inView = false;
    section.classList.remove('is-complete');
    cards.forEach(function(card) { card.classList.remove('is-active', 'is-done'); });
    nodes.forEach(function(node) { node.classList.remove('is-on', 'is-current'); });
    rails.forEach(function(rail) { rail.classList.remove('is-filled'); });
    resetUpload();
    resetShip();

    sectionObserver.disconnect();
    cardObserver.disconnect();
    if (singleColumn.matches) {
      cards.forEach(function(card) { cardObserver.observe(card); });
    } else {
      sectionObserver.observe(grid);
    }
  }

  function onModeChange() { setMode(); }
  if (singleColumn.addEventListener) singleColumn.addEventListener('change', onModeChange);
  else singleColumn.addListener(onModeChange);

  function onMotionChange() {
    if (!reducedMotion.matches) return;
    clearTimeout(timer);
    cardTimers.forEach(clearTimeout);
    runToken++;
    sectionObserver.disconnect();
    cardObserver.disconnect();
    resetUpload();
    resetShip();
    section.classList.remove('fp-steps--motion', 'is-complete');
  }
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onMotionChange);
  else reducedMotion.addListener(onMotionChange);

  setMode();
})();
